// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__i-xIz","name":"ConsentHeader_name__2op9D","birthday":"ConsentHeader_birthday__1-94R","skeleton":"ConsentHeader_skeleton__3hlrh"};